import { ReactNode } from "react";
import { AgGridReact, Card, Flex, Grid, Text } from "@jsq/ds/core";
import { type GetComplianceCaseQuery } from "~/graphql/supergraphTypes";
import { TypedAGGridCellRenderParams } from "~/pages/Compliance/ComplianceTable/types";
import { SPACING } from "~/styles/variables";
import { ruleHitsFromMetadata } from "../utils";
import { RuleHitRowItem } from "./types";

interface Props {
  complianceCase: GetComplianceCaseQuery["complianceCase"] | undefined;
}

export const RuleHitCard = ({ complianceCase }: Props) => {
  const allRowData: RuleHitRowItem[] = ruleHitsFromMetadata(
    complianceCase?.metaData as { transaction_monitoring_rules: [] },
  );

  const bankAccountColDefs: AgGridReact.AgGridReactProps["columnDefs"] = [
    {
      field: "reason",
      headerName: "Reason",
      wrapText: true,
      autoHeight: true,
      cellStyle: (_) => {
        return { lineHeight: "normal", padding: SPACING.MEDIUM };
      },
      cellRenderer: function (row: TypedAGGridCellRenderParams<RuleHitRowItem>) {
        if (!row?.data?.reason) {
          return;
        }
        const items: ReactNode[] = [];
        row.data.reason.forEach((item: string) => items.push(<>{item}</>));
        return <> {items} </>;
      },
    },
    {
      field: "details",
      headerName: "Details",
      wrapText: true,
      autoHeight: true,
      cellStyle: (_) => {
        return { lineHeight: "normal", padding: SPACING.MEDIUM };
      },
      cellRenderer: function (row: TypedAGGridCellRenderParams<RuleHitRowItem>) {
        if (!row?.data?.details) {
          return;
        }
        const items: ReactNode[] = [];
        row.data.details.forEach((item: string) => items.push(<p>{item}</p>));
        return <> {items} </>;
      },
    },
  ];

  const gridOptions: AgGridReact.AgGridReactProps["gridOptions"] = {
    autoSizeStrategy: {
      type: "fitGridWidth",
    },
    suppressCellFocus: true,
    domLayout: "autoHeight",
  };
  return (
    <Card>
      <Flex
        css={{ marginBottom: SPACING.LARGE }}
        alignContent="center"
        alignItems="center"
        justifyContent="space-between"
      >
        <Text variant="secondary-md">TRANSACTION MONITORING RULE HIT</Text>
      </Flex>

      <div style={{ overflow: "hidden" }}>
        <Grid
          gridOptions={gridOptions}
          rowData={allRowData}
          columnDefs={bankAccountColDefs}
          suppressColumnVirtualisation={true}
          suppressRowVirtualisation={true}
        ></Grid>
      </div>
    </Card>
  );
};
